import { useEffect, useState } from 'react';
import styled from 'styled-components';
import CalendarBody from './components/CalendarBody';
import CalendarHeader from './components/CalendarHeader';
import AdminSettings from './components/AdminSettings';
import MobileMenu from './components/MobileMenu';
import NoticeList from './components/NoticeList';
import { useAuth } from './context/AuthContext';

interface DatesType {
  prevMonth?: number[];
  thisMonth?: number[];
  nextMonth?: number[];
}

export default function Calendar() {
  const [year, setYear] = useState<number>(0);
  const [month, setMonth] = useState<number>(0);
  const [dates, setDates] = useState<DatesType>({});
  const [showSettings, setShowSettings] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<string>('schedule');
  const { logout } = useAuth();

  const getThisMonthDates = () => {
    const DATE: Date = new Date();
    return DATE;
  };

  const goToPrevMonth = () => {
    if (month <= 12) setMonth(month - 1);
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    }
  };

  const goToNextMonth = () => {
    if (month < 12) setMonth(month + 1);
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    }
  };

  const getCalendarDates = (year: number, month: number) => {
    const PREVLASTDATE: Date = new Date(year, month - 1, 0);
    const THISLASTDATE: Date = new Date(year, month, 0);
    const PREVLASTWEEKDAY = PREVLASTDATE.getDay();
    const THISLASTWEEKDAY = THISLASTDATE.getDay();
    const PREVLAST = PREVLASTDATE.getDate();
    const THISLAST = THISLASTDATE.getDate();
    const PREVMONTH: number[] = [];
    const THISMONTH: number[] = [];
    const NEXTMONTH: number[] = [];

    if (PREVLASTWEEKDAY < 6) {
      for (let i = PREVLASTWEEKDAY; i >= 0; i--) {
        PREVMONTH.push(PREVLAST - i);
      }
    }
    for (let i = 1; i <= THISLAST; i++) {
      THISMONTH.push(i);
    }
    if (THISLASTWEEKDAY < 6) {
      for (let i = 1; i <= 6 - THISLASTWEEKDAY; i++) {
        NEXTMONTH.push(i);
      }
    }
    return { prevMonth: PREVMONTH, thisMonth: THISMONTH, nextMonth: NEXTMONTH };
  };

  useEffect(() => {
    const DATE = getThisMonthDates();
    const YEAR = DATE.getFullYear();
    const MONTH = DATE.getMonth();
    setYear(YEAR);
    setMonth(MONTH + 1);
  }, []);

  useEffect(() => {
    const DATES = getCalendarDates(year, month);
    setDates(DATES);
  }, [year, month]);

  const handleLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      logout();
    }
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  const handleNavigate = (page: string) => {
    setCurrentPage(page);
  };

  const renderContent = () => {
    switch (currentPage) {
      case 'notice':
        return <NoticeList onBack={() => setCurrentPage('schedule')} />;
      case 'schedule':
      default:
        return (
          <>
            <CalendarHeader
              year={year}
              month={month}
              goToPrevMonth={goToPrevMonth}
              goToNextMonth={goToNextMonth}
            />
            <CalendarBody
              prevDates={dates.prevMonth}
              thisDates={dates.thisMonth}
              nextDates={dates.nextMonth}
              year={year}
              month={month}
            />
            {showSettings && <AdminSettings onClose={toggleSettings} />}
          </>
        );
    }
  };

  return (
    <Wrapper>
      <HeaderActions>
        <LeftSection>
          <MobileMenu onNavigate={handleNavigate} />
          <Title>부부마을 심방 스케줄</Title>
        </LeftSection>
        {/* <ButtonGroup>
          <ActionButton onClick={toggleSettings}>설정</ActionButton>
          <ActionButton onClick={handleLogout}>로그아웃</ActionButton>
        </ButtonGroup> */}
      </HeaderActions>
      {renderContent()}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const HeaderActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-left: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 5px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const ActionButton = styled.button`
  padding: 8px 16px;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e1e1e1;
  }
`;
